import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import http from "./plugins/axios";


Vue.config.productionTip = false;

new Vue({
  router,
  store,
  http,
  vuetify,
  render: h => h(App)
}).$mount("#app");
